import { useMemo, useSyncExternalStore } from 'react';

export function useMedia(query: string): boolean {
  const source = useMemo(() => {
    const media = window.matchMedia(query);
    return {
      subscribe: (callback: () => void) => {
        media.addEventListener('change', callback);
        return () => media.removeEventListener('change', callback);
      },
      snapshot: () => media.matches,
    };
  }, [query]);
  return useSyncExternalStore(source.subscribe, source.snapshot, () => false);
}

export function shortcut(value: string): string {
  if (/Mac|iPhone|iPad/.test(navigator.platform)) return value;
  return value.replaceAll('⇧', 'Shift+').replaceAll('⌘', 'Ctrl+').replaceAll('⌫', 'Delete');
}
